import React, { useContext } from "react";
import "./PdaNavbar.scss";
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { observer } from "mobx-react";
import { useLocation, useMatches } from "react-router";
import { dataContext } from "../../Context/contextProvider";
import { useNavigate } from "react-router";
import * as orderService from "../../Services/Http/OrderService";
import { LockUnlockResponse } from "../../Models/LockUnlockResponse";
import { toast } from "react-toastify";
import { useAuth } from "../../Context/useAuth";
import { LogoutRequest } from "../../Models/LogoutRequest";

interface Props {}
const PdaNavbar = observer((props: Props) => {
  const matches = useMatches();
  const { handle } = matches[matches.length - 1];
  const pageTitle: string = handle?.toString() || "";
  const dataStore = useContext(dataContext);
  const { logout, getDeviceId } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const handleBack = () => {
    //Order, Quote and Stock Request screens - matched exactly and first, because "salesorder" contains "order"
    //and would otherwise fall through to the pick list. Each item screen goes back to its list / customer screen.
    const exactBack: { [path: string]: string } = {
      "/salesorder": "/salesordercustomer",
      "/salesordercustomer": "/menu",
      "/quote": "/quotecustomer",
      "/quotecustomer": "/menu",
      "/stockrequest": "/stockrequests",
      "/stockrequests": "/menu",
    };
    const backTo = exactBack[pathname.toLowerCase().replace(/\/+$/, "")];
    if (backTo) {
      navigate(backTo);
      return;
    }
    //tally routes must come first - "tallyinorder" contains "order" and would
    //otherwise fall through to the pick list
    if (pathname.toLowerCase().includes("tallyoutline")) {
      navigate("/tallyoutorder");
      return;
    }
    if (pathname.toLowerCase().includes("tallyoutorder")) {
      navigate("/tallyout");
      return;
    }
    if (pathname.toLowerCase().includes("tallyout")) {
      navigate("/menu");
      return;
    }
    if (pathname.toLowerCase().includes("tallyinline")) {
      navigate("/tallyinorder");
      return;
    }
    if (pathname.toLowerCase().includes("tallyinorder")) {
      navigate("/tallyin");
      return;
    }
    if (pathname.toLowerCase().includes("tallyin")) {
      navigate("/menu");
      return;
    }
    if (pathname.toLowerCase().includes("orderpack")) {
      navigate("/packlist");
      return;
    }
    if (pathname.toLowerCase().includes("prepickorder")) {
      navigate("/prepick");
      return;
    }
    if (pathname.toLowerCase().includes("prepick")) {
      navigate("/menu");
      return;
    }
    if (pathname.toLowerCase().includes("order") && !pathname.includes("orders")) {
      navigate("/orders");
      return;
    }
    if (pathname.toLowerCase().includes("orders")) {
      unlockAll().then(() => {
        navigate("/menu");
      });
    } else {
      navigate("/menu");
    }
  };
  const getCompanyName = (): string => {
    let str = dataStore.userInfo?.dbPermission?.companyName || "";
    if (str.length > 17) {
      str = str.substring(0, 15) + "..";
    }
    return str;
  };
  //code of the warehouse location chosen at login, e.g. "BRS"
  const getLocationCode = (): string => {
    if (dataStore.location === null) {
      return "";
    }
    return dataStore.userInfo?.warehouseLocations?.find((l) => l.locationNo === dataStore.location)?.code || "";
  };
  const handleDisconnectFromDb = async () => {
    const logoutModel: LogoutRequest = {
      serverUrl: dataStore.serverUrl || "",
      dbKey: dataStore.dbKey || "",
      deviceId: getDeviceId() || "",
      username: dataStore?.userInfo?.username || "",
    };
    await logout(logoutModel);
    navigate("/login");
  };
  const unlockAll = async (): Promise<void> => {
    try {
      const unlockResponse: LockUnlockResponse = await orderService.unlockAllOrdersAPI(dataStore.serverUrl || "", dataStore.dbKey || "");
      if (!unlockResponse || (unlockResponse && !unlockResponse.success)) {
        toast.error("Couldn't acquire unlock.", { autoClose: false });
        return;
      }
    } catch (error: any) {
      toast.error(error?.message || error, { autoClose: false });
    }
  };

  return (
    <>
      <div className="ios-bar"></div>
      <Navbar expand="xxl" className="bg-body-tertiary rc-navbar-1 sticky-top-1" collapseOnSelect>
        <Container>
          {pageTitle.toLowerCase() === "menu" ? (
            <Button variant="light" style={{ visibility: "hidden" }} />
          ) : (
            <Button variant="light" onClick={handleBack}>
              <i className="fa fa-chevron-left" aria-hidden="true" />
            </Button>
          )}
          <Navbar.Brand>
            <b>{getCompanyName()}</b>
            {getLocationCode() && <b> ({getLocationCode()})</b>} | {pageTitle}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link onClick={handleDisconnectFromDb}>
                <i className="fa fa-sign-out" aria-hidden="true" /> Logout
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
});

export default PdaNavbar;
